import { BaseObject } from "../core/BaseObject";

export class Position extends BaseObject {
    positionId: number;
    positionName: string;
    hasEmployeeCategory: boolean;
    hasFullCycle: boolean;
}